module.exports = __webpack_public_path__ + "img/logo.924a97b2.png";